import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import no from "./no.json";

i18n.use(initReactI18next).init({
  // The actual translations
  resources: {
    en: {
      translation: en,
    },
    no: {
      translation: no,
    },
  },
  // Config
  lng: "no",
  fallbackLng: "no",
  interpolation: {
    escapeValue: false,
  },
});
